import type { InferRpcDefinition } from "@redotech/rpc/definition";

import { addDnsDomain } from "./schema/add-dns-domain";
import { beginDnsAttempt } from "./schema/begin-dns-attempt";
import { ensureDnsDomain } from "./schema/ensure-dns-domain";
import { getDnsRequirements } from "./schema/get-dns-requirements";
import { listDnsDomains } from "./schema/list-dns-domains";
import { releaseDnsDomain } from "./schema/release-dns-domain";
import { settleDnsAttempt } from "./schema/settle-dns-attempt";
import { startEntriSession } from "./schema/start-entri-session";

export const rpcDefinition = {
  addDnsDomain,
  beginDnsAttempt,
  ensureDnsDomain,
  getDnsRequirements,
  listDnsDomains,
  releaseDnsDomain,
  settleDnsAttempt,
  startEntriSession,
};

export type RedoDnsRpcDefinition = InferRpcDefinition<typeof rpcDefinition>;
